import { Injectable, EventEmitter } from '@angular/core';
import { AnalyticsEvent, triggerEvent } from '../utils/analytics';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  isComparisonModalOpen: EventEmitter<boolean> = new EventEmitter();
  private _isComparisonModalVisible = false;
  private _closingFocusTarget: HTMLElement | null;

  public setIsComparisonModalVisible(isVisible: boolean) {
    this._isComparisonModalVisible = isVisible;
    this.isComparisonModalOpen.emit(isVisible);
    if (!isVisible) {
      triggerEvent(AnalyticsEvent.compareClose);
      this._closingFocusTarget && this._closingFocusTarget.focus();
    }
  }

  public getIsComparisonModalVisible() {
    return this._isComparisonModalVisible;
  }

  // For now, the target will always be the hamburguer menu button.
  public setClosingFocusTarget(target: HTMLButtonElement) {
    this._closingFocusTarget = target;
  }
}
